// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1qtYR","loaderOuter":"PageOverlayLoader_loaderOuter__1q36r"};